import React, { useState } from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import timezones from '../../utils/timezones.json';

const CreateTimeTemplate = () => {
  const dispatch = useDispatch();
  const { timeTemplateCreated, loadingTimeTemplate } = useSelector((state) => state.general);

  const [name, setName] = useState(undefined);
  const [selectedTimezone, setSelectedTimezone] = useState('UTC');
  const [specificTime, setSpecificTime] = useState([{ hour: 12, minute: 0 }]);
  const [rangeStartHour, setRangeStartHour] = useState(0);
  const [rangeEndHour, setRangeEndHour] = useState(0);
  const [rangeInterval, setRangeInterval] = useState(15);

  const handleSpecificTimeChange = (index, field, value) => {
    const newSpecificTime = [...specificTime];
    newSpecificTime[index][field] = value;
    setSpecificTime(newSpecificTime);
  };
  const handleDeleteSpecificTime = (index) => {
    const newSpecificTime = specificTime.filter((_, i) => i !== index);
    setSpecificTime(newSpecificTime);
  };

  if (timeTemplateCreated?._id) {
    dispatch(generalSet({ reduxField: 'timeTemplateCreated', value: {} }));
    window.location.href = '/timeTemplates';
  }

  console.log({ timezones, selectedTimezone });

  return (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center border-bottom'>
        <h1>Create A Time Template</h1>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-6 p-3 border'>
          Name
          <input
            type='text'
            className='form-control'
            placeholder='Template name...'
            style={{ textAlign: 'center' }}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <Select
          className='col-md-6'
          options={timezones.map((timezone) => ({
            value: timezone.abbr,
            label: `${timezone.text} (${timezone.abbr}) - ${timezone.value}`,
          }))}
          value={selectedTimezone}
          placeholder={selectedTimezone}
          onChange={(selectedOption) =>
            setSelectedTimezone(typeof selectedOption.value === 'string' ? selectedOption.value : 'UTC')
          }
          isSearchable
        />
      </div>

      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-12 d-flex justify-content-center'>
          <small>
            <b>Note: </b> All rules are under UTC timzone{' '}
          </small>
        </div>
        <div className='col-md-6 p-3 border'>
          <div className='d-flex justify-content-between align-items-center'>
            <select
              className='form-control'
              value={rangeStartHour}
              onChange={(e) => setRangeStartHour(parseInt(e.target.value) || 0)}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={`start-${i}`} value={i}>
                  {i}
                </option>
              ))}
            </select>
            <select
              className='form-control'
              value={rangeEndHour}
              onChange={(e) => setRangeEndHour(parseInt(e.target.value) || 0)}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={`end-${i}`} value={i}>
                  {i}
                </option>
              ))}
            </select>
            <select
              className='form-control'
              value={rangeInterval}
              onChange={(e) => setRangeInterval(parseInt(e.target.value) || 15)}
            >
              <option value={15}>15</option>
              <option value={30}>30</option>
              <option value={45}>45</option>
              <option value={60}>60</option>
            </select>
            <button
              className='btn btn-outline-dark'
              onClick={() => {
                const start = Math.min(rangeStartHour, rangeEndHour);
                const end = Math.max(rangeStartHour, rangeEndHour);
                const interval = rangeInterval;
                const additions = [];
                for (let h = start; h <= end; h++) {
                  for (let m = 0; m < 60; m += interval) {
                    const exists = specificTime.some((t) => parseInt(t.hour) === h && (parseInt(t.minute) || 0) === m);
                    if (!exists) {
                      additions.push({ hour: h, minute: m });
                    }
                  }
                }
                if (additions.length > 0) {
                  setSpecificTime([...specificTime, ...additions]);
                }
              }}
            >
              Add Range
            </button>
          </div>
        </div>
        <div className='col-md-4'>
          {specificTime.map((time, index) => (
            <div
              key={index}
              className='d-flex justify-content-between align-items-center'
              data-aos='fade-down'
              data-aos-delay='200'
            >
              <select
                className='form-control'
                value={time.hour}
                onChange={(e) => handleSpecificTimeChange(index, 'hour', e.target.value)}
              >
                {Array.from({ length: 24 }, (_, i) => (
                  <option key={i} value={i}>
                    {i}
                  </option>
                ))}
              </select>
              <select
                className='form-control'
                value={time.minute || 0}
                onChange={(e) => handleSpecificTimeChange(index, 'minute', e.target.value)}
              >
                <option value={0}>00</option>
                <option value={15}>15</option>
                <option value={30}>30</option>
                <option value={45}>45</option>
              </select>
              <button className='btn btn-outline-danger' onClick={() => handleDeleteSpecificTime(index)}>
                <i className='fa fa-trash' aria-hidden='true'></i>
              </button>
            </div>
          ))}
          <button
            className='btn btn-outline-dark mt-2'
            onClick={() => setSpecificTime([...specificTime, { hour: 12, minute: 0 }])}
          >
            Add Time
          </button>
        </div>
      </div>
      {typeof name === 'string' && name.length > 0 && specificTime.length > 0 ? (
        <div className='row d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
          <button
            className='btn btn-outline-dark'
            disabled={loadingTimeTemplate}
            onClick={() => {
              dispatch(generalSet({ reduxField: 'loadingTimeTemplate', value: true }));
              dispatch(
                apiAction({
                  route: 'timeTemplates/createTimeTemplate',
                  reduxField: 'timeTemplateCreated',
                  name,
                  template: specificTime,
                  timezone: selectedTimezone,
                  setLoading: 'loadingTimeTemplate',
                }),
              );
            }}
          >
            {loadingTimeTemplate ? <Spinner /> : 'Create Template'}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default CreateTimeTemplate;
